import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';

const descendantCountBadgeFont = (fontSize: number) =>
  `${fontSize}px ${ARDOQ_DEFAULT_FONT_FAMILY}`;
export { descendantCountBadgeFont };
